// AUTO-GENERATED by generate-rxdb-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { defaultHooks } from '../defaults'

const name = 'teammembers'

/**
 * TeamMember Model Interface (auto-generated from Drizzle schema)
 */
export interface TeamMemberModel {
  id: string
  orgId: string
  workspaceId?: string
  userId?: string
  createdAt: string
  updatedAt: string
  metadata?: Record<string, unknown>
  extended?: Record<string, unknown>
  userName: string
  slug?: string
  userEmail?: string
  userAvatar?: string
  role: string
  isAgent: boolean
  joinedAt?: string
  raciAssignments?: Record<string, unknown>
  productId?: string
  tenantId?: string
  lastHeartbeat?: string
  containerStatus?: string
}

export const schema = {
  title: name,
  version: 0,
  primaryKey: 'id',
  type: 'object',
  properties: {
    id: {
      type: 'string',
      maxLength: 100,
    },
    orgId: {
      type: 'string',
      maxLength: 100,
    },
    workspaceId: {
      type: 'string',
      maxLength: 100,
    },
    userId: {
      type: 'string',
      maxLength: 100,
    },
    createdAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    updatedAt: {
      type: 'string',
      maxLength: 200,
      format: 'date-time',
    },
    metadata: {
      type: 'object',
    },
    extended: {
      type: 'object',
    },
    userName: {
      type: 'string',
      maxLength: 200,
    },
    slug: {
      type: 'string',
      maxLength: 200,
    },
    userEmail: {
      type: 'string',
      maxLength: 200,
    },
    userAvatar: {
      type: 'string',
      maxLength: 200,
    },
    role: {
      type: 'string',
      maxLength: 50,
    },
    isAgent: {
      type: 'boolean',
    },
    joinedAt: {
      type: 'string',
      maxLength: 200,
    },
    raciAssignments: {
      type: 'object',
    },
    productId: {
      type: 'string',
      maxLength: 100,
    },
    tenantId: {
      type: 'string',
      maxLength: 100,
    },
    lastHeartbeat: {
      type: 'string',
      maxLength: 50,
      format: 'date-time',
    },
    containerStatus: {
      type: 'string',
      maxLength: 20,
      enum: ['running', 'stopped', 'error', 'unknown'],
    },
  },
  required: ['id', 'orgId', 'createdAt', 'updatedAt', 'userName', 'role', 'isAgent'],
  indexes: [
    ['orgId', 'createdAt'],
    ['orgId', 'role'],
  ],
}

export const migrationStrategies = {}

export const Collection = {
  name,
  schema,
  hooks: {
    ...defaultHooks({ name }),
  },
  migrationStrategies,
}
